document.addEventListener("alpine:init", () => {
    Alpine.data("loadMorePosts", (data) => ({
        posts: [],
        paged: 1,
        hasMore: true,
        noResults: false,
        currentPost: data.currentPost || '',
        postType: data.postType || '',
        postsPerPage: data.postsPerPage || 12,
        totalPosts: 0,
        categoryFilter: 'all_categories',
        tagFilter: 'all_tags',
        searchQuery: '',
        initialCategories: data.initialCategories || '',
        initialTags: data.initialTags || '',

        async fetchPosts(reset = false) {
            if (reset) {
                this.paged = 1;
                this.posts = [];
                this.hasMore = true;
                this.noResults = false;
            }

            let formData = new FormData();
            formData.append("action", "load_more_posts");
            formData.append("paged", this.paged);
            formData.append("post_type", this.postType);
            formData.append("posts_per_page", this.postsPerPage);
            formData.append("category", this.categoryFilter);
            formData.append("tag", this.tagFilter);
            formData.append("initial_categories", this.initialCategories);
            formData.append("initial_tags", this.initialTags);
            formData.append("current_post", this.currentPost);

            let response = await fetch(appAjax.ajax_url, {
                method: "POST",
                body: formData,
            });

            let data = await response.json();

            if (reset || this.totalPosts === 0) {
                this.totalPosts = data.total_posts;
            }

            if (data.posts.length === 0) {
                this.hasMore = false;
                this.noResults = this.paged === 1;
            } else {
                this.posts.push(...data.posts.map(post => ({
                    id: post.id,
                    post_type: post.post_type,
                    title: post.title,
                    label: post.label,
                    link_text: post.link_text,
                    excerpt: post.excerpt,
                    url: post.url,
                    target: post.target,
                    thumbnail: post.thumbnail.replace(/\bauto,\s?/g, ''),
                    tag: post.tag,
                    price: post.price,
                    price_from: post.price_from,
                    publish_date: post.publish_date,
                    start_date: post.start_date,
                    end_date: post.end_date,
                    time: post.time,
                    unpublish_date: post.unpublish_date,
                    blog_id: post.blog_id,
                    blog_name: post.blog_name,
                    blog_color: post.blog_color,
                })));

                this.updateSchema();

                this.paged++;
                this.noResults = false;

                if (this.posts.length >= this.totalPosts) {
                    this.hasMore = false;
                }
            }
        },

        loadMore() {
            this.fetchPosts();
        },

        filterPosts() {
            this.fetchPosts(true);
        },

        setCategoryFilter(category) {
            this.categoryFilter = category;
            this.filterPosts();
        },

        setTagFilter(tag) {
            this.tagFilter = tag;
            this.filterPosts();
        },

        updateSchema() {
            const existingScript = document.getElementById('dynamic-schema');
            if (existingScript) existingScript.remove();

            const schema = {
                '@context': 'https://schema.org',
                '@type': 'ItemList',
                'itemListElement': this.posts.map((post, index) => {
                    let type = 'Article'; // default

                    switch(post.post_type) {
                        case 'event': type = 'Event'; break;
                        case 'activity':
                        case 'conference_activity': type = 'TouristAttraction'; break;
                        case 'offer':
                        case 'conference_offer': type = 'Offer'; break;
                        case 'conference_room':
                        case 'hotel_room': type = 'Room'; break;
                        case 'menu': type = 'Menu'; break;
                        case 'post':
                        case 'page': type = 'Article'; break;
                    }

                    const item = {
                        '@type': type,
                        'name': post.title || '',
                        'url': post.url || '',
                        'description': post.excerpt || '',
                        'image': post.thumbnail || ''
                    };

                    if (post.post_type === 'event') {
                        item.startDate = post.start_date || '';
                        item.location = {
                            '@type': 'Place',
                            'name': post.location_name || '',
                            'address': post.location_address || ''
                        };
                    }

                    if (['offer', 'conference_offer'].includes(post.post_type)) {
                        item.price = post.price || '';
                        item.priceCurrency = 'SEK';
                    }

                    if (['conference_room', 'hotel_room'].includes(post.post_type)) {
                        item.occupancy = {
                            '@type': 'QuantitativeValue',
                            'value': post.capacity || ''
                        };
                    }

                    if (['post', 'page'].includes(post.post_type)) {
                        item.datePublished = post.publish_date || '';
                    }

                    return {
                        '@type': 'ListItem',
                        'position': index + 1,
                        'url': post.url || '',
                        'item': item
                    };
                })
            };

            const scriptTag = document.createElement('script');
            scriptTag.type = 'application/ld+json';
            scriptTag.id = 'dynamic-schema';
            scriptTag.text = JSON.stringify(schema, null, 2);
            document.head.appendChild(scriptTag);
        },

        init() {
            this.loadMore();
        }
    }));
});
